export const publicAccessType = "tUmtnb";
export default {publicAccessType};